import {Model} from "vue-mc";

export class Subscriber extends Model
{
    defaults() {
        return {
            id: null,
            name: '',
            surname: '',
            email: '',
            mobile: '',
        }
    }
}